<template>
  <v-snackbar v-model="show" :timeout="timeout" :color="color">
    {{ text }}
  </v-snackbar>
</template>

<script>
export default {
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === `snackbar/setSnackbarText`) {
        this.text = state.snackbar.snackbarText;
        this.timeout = state.snackbar.timeout;
        this.color = state.snackbar.color;
        this.show = true;
      }
    });
  },
  data() {
    return {
      show: false,
      text: "",
      timeout: 1000,
      color: "success", // success,error,warning,
    };
  },
};
</script>
